import DataState from './data-state';
import Action from '../../state/action';

const dataReducer = (state: DataState, action: Action): DataState => {
  switch (action.type) {
    case 'fetch-data':
      return {
        type: 'loading',
        url: action.url,
      };
    case 'report-data-error':
      return {
        type: 'error',
        error: action.error,
        retry: action.retry,
      };
    case 'store-data':
      return {
        type: 'loaded',
        data: action.data,
      };
    case 'process-data':
      return {
        type: 'processed',
        jobs: action.jobs,
      };
    default:
      return state;
  }
};

export default dataReducer;
